import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { GenericSelect } from '../../components';
import { InputBaseModel, InputModelWithSource } from '../../models';
import { InputWithSource } from '../../componentTypes';
import { InputIds } from '../../misc';

const standardDeductionIds: string[] = [
    InputIds.Deductions.Brokerage,
    InputIds.Deductions.Commission,
    InputIds.Deductions.TaxOnPremium
];

const hasApplicableDeduction = (inputs: InputBaseModel[]) => {
    const hasStandardDeduction = inputs.some(input => standardDeductionIds.includes(input.id) && input.hasValue);

    if (hasStandardDeduction) {
        return true;
    }

    const typeInputs = inputs
        .filter(input => input.id.startsWith(InputIds.Deductions.DeductionType))
        .sort((a, b) => a.id.localeCompare(b.id));
    const valueInputs = inputs
        .filter(input => input.id.startsWith(InputIds.Deductions.DeductionValue))
        .sort((a, b) => a.id.localeCompare(b.id));

    return typeInputs.some((typeInput, index) => typeInput.hasValue && valueInputs[index]?.hasValue);
};

const CalculationBasisInput: InputWithSource = ({ input }) => {
    const required = hasApplicableDeduction(input.inputsAtSameLevel);

    React.useEffect(() => {
        if (input.required === required) {
            return;
        }

        input.setRequired(required);
        input.validate();
    }, [input, input.required, required]);

    return <GenericSelect label={input.name} input={input} />;
};

CalculationBasisInput.meta = {
    inputType: InputModelWithSource.name
};

export default observer(CalculationBasisInput);
